 
// Function to generate reusable custom styles
export const generateCustomStyles = (fieldName, formik) => ({
    control: (provided, state) => ({
      ...provided,
      // height: '46px',
      // borderRadius:'10px',
    
      borderColor: formik.touched[fieldName] && formik.errors[fieldName] ? 'red' : provided.borderColor,
      '&:hover': {
        borderColor: formik.touched[fieldName] && formik.errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
      },
      
    })
  });